module.exports = __webpack_public_path__ + "static/media/virgen-coromoto-300.964612dc.jpg";